import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../page/Home.vue";
import homeMobilePage from "../page/homeMobilePage.vue"
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home
  },
  {
    path: "/m",
    component: homeMobilePage
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
